export default "__VITE_ASSET__BljWt3MH__"